import { useTranslation } from "react-i18next";
import TaskForm from "src/components/forms/TaskForm";
import TaskFormWrapper from "src/components/forms/TaskForm/TaskFormWrapper";
import ExternTaskMiddleware from "src/components/middlewares/ExternTaskMiddleware";
import TaskDetailWrapper from "src/components/tasks/detail/TaskDetailWrapper";
import useLimits from "src/hooks/api/services/auth/useLimits";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useTaskFormSteps from "src/hooks/api/tasks/useTaskFormSteps";
import useAuth from "src/hooks/selectors/useAuth";
import useModules from "src/hooks/selectors/useModules";

export default function TaskPublishView() {
	const { modules } = useModules();
	const { limits } = useLimits();
	const { t: translatedStep } = useTranslation("tasks", {
		keyPrefix: "steps",
	});
	const { task, status } = useTaskForm();
	const auth = useAuth();
	const { isFinal, currentStep } = useTaskFormSteps();
	const showMiddleware =
		!modules?.includes("extern-task") ||
		!limits?.published_tasks?.is_available ||
		!auth.has_subscription;

	return (
		<TaskDetailWrapper
			{...{ task }}
			loading={status === "loading"}
			options={{
				hideTabs: true,
				hideFields: true,
			}}
		>
			{showMiddleware ? (
				<div className="container flex flex-col flex-1">
					<ExternTaskMiddleware />
				</div>
			) : (
				<div className="container">
					<div className="mt-8">
						{task?.id && (
							<TaskFormWrapper>
								{currentStep ===
									translatedStep("planning.questions") && (
									<TaskForm.AIQuestions />
								)}
								{currentStep ===
									translatedStep("planning.extra") && (
									<TaskForm.Extra />
								)}

								{currentStep ===
									translatedStep("description") && (
									<TaskForm.Description />
								)}
								{currentStep === translatedStep("budget") && (
									<TaskForm.Budget
										amountLocked={
											task?.student_hid ? true : false
										}
									/>
								)}
								{currentStep === translatedStep("shifts") && (
									<TaskForm.Subtasks />
								)}
								{currentStep === translatedStep("location") && (
									<TaskForm.Address />
								)}
								{currentStep === translatedStep("date") && (
									<TaskForm.Target />
								)}
								{currentStep === translatedStep("invite") && (
									<TaskForm.StudentPool />
								)}
								{currentStep === translatedStep("form") && (
									<TaskForm.Interview />
								)}

								{isFinal &&
									!modules?.includes(
										"ai-description-creation"
									) && <TaskForm.Summary />}
								{isFinal &&
									modules?.includes(
										"ai-description-creation"
									) && <TaskForm.SummaryAI />}
							</TaskFormWrapper>
						)}
					</div>
				</div>
			)}
		</TaskDetailWrapper>
	);
}
